import OpenQuestion from 'models/common/form/question/open/OpenQuestion';

export default class UrlOpenQuestion extends OpenQuestion {}
